import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import ShowCard from "../restaurant/view/ShowCard";
import { saveAs } from "file-saver";

export const ViewOrders = () => {
  const { id } = useParams();
  const [cardview, toggleCardview] = useState(false);

  const [order, setOrder] = useState({});

  useEffect(() => {
    const fetchOrder = async () => {
      const response = await axios.get("/api/orders/" + id);
      const data = await response.data;
      setOrder(data);
    }
    let componentMount = true
    if (componentMount) {
      fetchOrder();
    }
    return () => {
      componentMount = false
    }
  }, [id]);


  const {
    order_time,
    add_on,
    time,
    address,
    category,
    discount,
    email_id,
    end_date,
    meal_type,
    notes,
    order_id,
    card,
    phone,
    plan_name,
    customer_price,
    delivery_fee,
    restaurant_id,
    service_rate,
    service_fee,
    taxes,
    tax,
    tip,
    total,
    restaurant,
    start_date,
    user_id,
    user_name,
    restaurant_address
  } = order;

  const closeHandler = (state) => {
    toggleCardview(state);
  };

  const downloadPdf = async () => {
    const response = await axios.get("/api/orders/fetch-pdf", {
      responseType: "blob",
    });
    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    saveAs(pdfBlob, "receipt.pdf");
  };
  
  if (!cardview) {
    return (
      <>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-8">
            <h2>Order Details</h2>
          </div>
          <div className="col-lg-4">
            <div className="title-action">
              <button onClick={downloadPdf} className="btn btn-primary">
                <i className="fa fa-print" /> Print Invoice{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="wrapper wrapper-content">
          <div className="ibox-content p-xl">
            <div className="row">
              <div className="col-sm-6">
                <h5>From:</h5>

                <address>
                  <strong>{restaurant + "," + restaurant_id}</strong>
                  <br />
                  {(restaurant_address && restaurant_address.locality) +
                    ", " +
                    (restaurant_address && restaurant_address.city)}
                  <br />
                  {restaurant_address && restaurant_address.state + " -" + restaurant_address && restaurant_address.postal_code}
                  <br />
                  <abbr title="Phone">P:</abbr> {restaurant_address && restaurant_address.phone}
                </address>
              </div>
              <div className="col-sm-6 text-right">
                <h4 className="text-navy">{"#" + order_id}</h4>
                <span>To:</span>
                <address>
                  <strong>{user_name + " (" + user_id + ")"}</strong>
                  <br />
                  {address &&
                    address.address_type +
                    ", " +
                    address.addressLine1 +
                    ", " +
                    address.addressLine2}
                  <br />
                  {address && address.city + ", " + address.postal_code}
                  <br />
                  <abbr title="Mobile">M:</abbr> {phone}
                  <br />
                  <abbr title="Email">E:</abbr> {email_id}
                </address>
                <p>
                  <span>
                    <strong>Ordered at:</strong>{" "}
                    {order_time}
                  </span>
                </p>
              </div>
            </div>
            <div className="table-responsive m-t">
              <table className="table invoice-table">
                <thead>
                  <tr>
                    <th>Plan</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Customer Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div>
                        <strong>
                          {plan_name}
                        </strong>
                      </div>
                      <small>{meal_type + ", " + category + "-" + time}</small>
                    </td>
                    <td>{start_date}</td>
                    <td>{end_date}</td>
                    <td>{"$" + parseFloat(customer_price).toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* /table-responsive */}
            <table className="table invoice-total">
              <tbody>
                <tr>
                  <td>
                    <strong>Sub Total :</strong>
                  </td>
                  <td>${customer_price}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Delivery Fee :</strong>
                  </td>
                  <td>${delivery_fee}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Service Fee ({service_rate}%):</strong>
                  </td>
                  <td>${parseFloat(service_fee).toFixed(2)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Tip :</strong>
                  </td>
                  <td>${tip}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Discount :</strong>
                  </td>
                  <td>${discount || 0}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Taxes ({parseFloat(taxes).toFixed(2)}%):</strong>
                  </td>
                  <td>${parseFloat(tax).toFixed(2)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>TOTAL :</strong>
                  </td>
                  <td>${parseFloat(total).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
            <div className="well m-t">
              <strong>Comments: </strong>
              {notes}
            </div>
            <div className="well m-t">
              <table className="table table-bordered table-sm">
                <thead className="thead-primary">
                  <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Qty</th>
                    <th scope="col">Order Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(add_on) && add_on.length !== 0 ? (
                    add_on.map((item) =>
                      item.map((item, key) => (
                        <tr key={key}>
                          <td className="td">{item.item}</td>
                          <td>{item.rate}</td>
                          <td>{item.qty}</td>
                          <td>{item.order_date}</td>
                        </tr>
                      ))
                    )
                  ) : (
                    <tr className="text-center">
                      <td colSpan={4}>No add-on for this user</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* </div> */}
        </div>
      </>
    );
  } else {
    return <ShowCard card={card} closeHandler={closeHandler} />;
  }
};
